import { STATUS } from "@/constants/statuses";
import { Store, StoreConfig } from "@datorama/akita";
import { injectable } from "tsyringe";

import ReviewsListInfoEntity from "../entities/ReviewsListInfoEntity";

export type ReviewsListInfoState = {
    totalCount: ReviewsListInfoEntity["totalCount"] | null;
    averageRating: ReviewsListInfoEntity["averageRating"] | null;
    ratesInfo: ReviewsListInfoEntity["ratesInfo"];
    status: STATUS;
};

export function createInitialState(): ReviewsListInfoState {
    return {
        totalCount: null,
        averageRating: null,
        ratesInfo: [],
        status: STATUS.VIRGIN,
    };
}

@injectable()
@StoreConfig({ name: "reviews_list_info_store" })
class ReviewsListInfoStoreBase extends Store<ReviewsListInfoState> {
    constructor() {
        super(createInitialState());
    }

    setStatus(status: STATUS): void {
        this.update((state) => ({ ...state, status }));
    }

    getStatus(): STATUS {
        return this.getValue().status;
    }
}

export default ReviewsListInfoStoreBase;
